//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbInfographicBox from '../rb-infographic-box/rb-infographic-box.vue'
export default {
  name: 'rb-benefits-polarized-lenses',
  components: {
    RbInfographicBox,
  },
}
